import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bind"
};
const _hoisted_2 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_form = _resolveComponent("van-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
    width: "100%",
    src: require('../../assets/images/bg.jpg')
  }, null, 8, ["src"]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "header"
  }, [_createElementVNode("p", null, "绑定"), _createElementVNode("p", null, "欢迎来到家校通")], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    class: "icon",
    width: "65%",
    src: require('../../assets/images/login_icon.png')
  }, null, 8, ["src"]), _createVNode(_component_van_form, {
    ref: "formRef",
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.jobNum,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelForm.jobNum = $event),
        required: "",
        clearable: "",
        name: "jobNum",
        label: "",
        placeholder: "请输入学号",
        rules: [{
          required: true,
          message: '请输入学号'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelForm.name = $event),
        required: "",
        clearable: "",
        name: "name",
        label: "",
        placeholder: "请输入姓名",
        rules: [{
          required: true,
          message: '请输入姓名'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.modelForm.phone = $event),
        required: "",
        clearable: "",
        type: "tel",
        name: "phone",
        label: "",
        placeholder: "请输入手机号码",
        rules: [{
          required: true,
          message: '请输入手机号码'
        }, {
          validator: _ctx.validPhone,
          message: '请输入正确的手机号码'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.code,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.modelForm.code = $event),
        center: "",
        required: "",
        clearable: "",
        name: "code",
        label: "",
        maxlength: "4",
        placeholder: "请输入短信验证码",
        rules: [{
          required: true,
          message: '请输入短信验证码'
        }]
      }, {
        button: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          round: "",
          hairline: "",
          size: "mini",
          color: "#5282F0",
          disabled: _ctx.codeDisabled,
          onClick: _ctx.getCode
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.codeText), 1)]),
          _: 1
        }, 8, ["disabled", "onClick"])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_button, {
      class: "submit",
      round: "",
      loading: _ctx.loading,
      "loading-text": "提交中...",
      disabled: _ctx.loading,
      color: "linear-gradient(24deg, #5282F0, #608DF4)",
      size: "small",
      "native-type": "submit"
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 立即绑定 ")])),
      _: 1
    }, 8, ["loading", "disabled"])]),
    _: 1
  }, 8, ["onSubmit"])])]);
}